import { getBodyAgeGroup } from '#assets/images/gutXAxis';
import { GutXAxisBody } from '#components/GutXAxisBody';
import type { GutXAxisOrgan } from '@repo/types';
import { AgeGroup, getAgeGroup } from '@repo/utils';
import c from 'classnames';
import styles from './OrganBadge.module.css';

type OrganBadgeProps = {
  organ: GutXAxisOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  sex: string;
};

/**
 * An organ as a circular crop of the same body the map draws, so the two can
 * never disagree about a kit's artwork or its colour.
 */
export default function OrganBadge({
  organ,
  age,
  pregnant,
  sex,
}: OrganBadgeProps) {
  // Only an adult's intestines make room for a baby, so only they crop differently.
  const withBaby = pregnant && getAgeGroup(age) === AgeGroup.ADULT;

  return (
    <span className={c(styles.badge, styles[organ.flag_level])}>
      <GutXAxisBody
        className={c(
          styles.stage,
          styles[organ.lookup_code],
          styles[getBodyAgeGroup({ age, pregnant })],
          withBaby && styles.pregnant,
        )}
        organs={[organ]}
        age={age}
        pregnant={pregnant}
        sex={sex}
        waitForImages={false}
      />
    </span>
  );
}
